export { default as ProductsIndexPageSubHeader } from './ProductsIndexPageSubHeader';
